import { Component, inject, Input } from '@angular/core';
import {
  FlexibleColumn,
  IpoLanguageService,
  IpoStringService,
} from '@ip-only/front-end-library';
import { getFormattedYearMonthDate } from '../../../shared/util/date-helper';
import { QueryParamService } from '../../../shared/util/query-params.service';
import {
  ConstructionDocumentItem,
  ConstructionDocumentsResponse,
} from '../../entities/construction-documents-entities';
import { ConstructionDocumentsService } from '../../service/construction-documents.service';
import {
  generateSizeString,
  handleOnClickConstructionDocumentsItem,
} from '../folder-content-helper';
import { folderContentColumns } from './folder-content-columns';

@Component({
  selector: 'app-folder-content-desktop',
  templateUrl: './folder-content-desktop.component.html',
  styleUrl: './folder-content-desktop.component.scss',
  standalone: false,
})
export class FolderContentDesktopComponent {
  private readonly constructionDocumentsService = inject(
    ConstructionDocumentsService,
  );

  @Input() folderContent: ConstructionDocumentsResponse;
  columns: FlexibleColumn[] = folderContentColumns;
  language$ = this.languageService.getLanguage$();

  constructor(
    private languageService: IpoLanguageService,
    private translate: IpoStringService,
    private queryParamService: QueryParamService,
  ) {}

  mapTableId(item: ConstructionDocumentItem) {
    return item.itemId;
  }

  generateSizeString(item: ConstructionDocumentItem) {
    return generateSizeString(item.childCount, item.sizeLabel, this.translate);
  }

  formatDate(date: string) {
    return getFormattedYearMonthDate(date);
  }

  handleOnClick(item: ConstructionDocumentItem) {
    handleOnClickConstructionDocumentsItem(
      item,
      this.queryParamService,
      this.constructionDocumentsService,
    );
  }
}
